import { OptionsService } from './../services/options-service';
import { ClientCookieService } from '../services/client-cookie-service';
import { getUrlVars, removeUrlVars, dispatchCustomEvent, getParentCookies, getGoogleCookieId } from '../helpers/helpers';
import { Dependencies } from '../interfaces/dependencies-types';
import DependenciesInjector from '../helpers/dependencies-injector';
declare global {
    interface Window {
        _FSAccountMenu: any;
    }
}
export class AccountsController implements Dependencies {
    // injections
    private clientCookieService: ClientCookieService;
    private optionsService: OptionsService;
    private clientFullName: string;

    // instance variables.
    private webAccountsUrl = '';
    private appUrl = '';
    private logoutText = 'Log Out';

    private avatarUrlDesktop: string;
    private avatarUrlMobile: string;
    private loginSettings: any;

    private loginHandler: Function;
    private logoutHandler: Function;

    public async initialize() {
        this.clientCookieService = await DependenciesInjector.getRegistered('ClientCookieService');
        this.optionsService = await DependenciesInjector.getRegistered('OptionsService');

        this.webAccountsUrl = this.optionsService.getObfClientSettings().accounts_url;
        this.appUrl = this.optionsService.getObfClientSettings().app_url;

        // get all menuContainers
        this.fetchAllWebAccountsContainers();

        if (
            this.loginSettings?.waLoginContainerDesktop.length ||
            this.loginSettings?.waLoginContainerMobile.length ||
            this.loginSettings?.waMenuContainer.length
        ) {
            this.addStyleForLogin();
        }

        if (getUrlVars().csid) {
            const csid = getUrlVars().csid;
            removeUrlVars('csid');
            
            if (getUrlVars().csid_expire_time) {
                const csidЕxpireТime = getUrlVars().csid_expire_time;
                removeUrlVars('csid_expire_time');
                this.setUserCookie(csid, parseInt(csidЕxpireТime));
            } else {
                this.setUserCookie(csid);
            }
        }
    }

    public setUserCookie(csid: any, expire?: number) {
        // disable setting new cookie when we are on accounts.
        if (!this.webAccountsUrl.includes(location.origin)) {
            this.clientCookieService.setCookie('user-login', csid, expire);
        }
    }

    public getUserCookie() {
        return this.clientCookieService.getCookie('user-login') || this.clientCookieService.getCookie('user-login-lax');
    }

    public deleteUserCookie() {
        return this.clientCookieService.removeCookie('user-login');
    }

    public registerCustomLogoutHandler(handler: Function) {
        this.logoutHandler = handler
    }

    private fetchAllWebAccountsContainers() {
        this.loginSettings = {
            waLoginContainerDesktop: document.querySelectorAll('[data-wa-login=\'desktop\']'),
            waLoginContainerMobile: document.querySelectorAll('[data-wa-login=\'mobile\']'),
            waMenuContainer: document.querySelectorAll('[data-menu-layout]'),
        }

        // setup hightJack for elements inside in containers.
        this.executeOnAllWAContainers((container, type) => {
            this.hightJackSomeElementsFromContainer(container);
        })
    }

    private executeOnAllWAContainers(fun: (container: HTMLElement, type: 'desktop' | 'mobile' | 'all') => void) {

        for (let index = 0; index < this.loginSettings.waMenuContainer.length; index++) {
            const loginContainer = this.loginSettings?.waMenuContainer[index];
            fun(loginContainer, 'all')
        }
        for (let index = 0; index < this.loginSettings.waLoginContainerDesktop.length; index++) {
            const loginContainer = this.loginSettings?.waLoginContainerDesktop[index];
            fun(loginContainer, 'desktop')
        }

        for (let index = 0; index < this.loginSettings.waLoginContainerMobile.length; index++) {
            const loginContainer = this.loginSettings?.waLoginContainerMobile[index];
            fun(loginContainer, 'mobile')
        }

    }


    private hightJackSomeElementsFromContainer(loginContainer: HTMLElement) {
        loginContainer.addEventListener('click', (event: any) => {

            if (event && event.target && event.target.className === 'wrap-element') {
                let loggedMenuContainer = document.getElementsByClassName('accounts-menu-holder');

                if (loggedMenuContainer && loggedMenuContainer.length && loggedMenuContainer[0].classList.contains('show-logged-menu')) {
                    loggedMenuContainer[0].classList.remove('show-logged-menu');
                } else {
                    loggedMenuContainer[0].classList.add('show-logged-menu');
                }
            }

            if (
                event.target.nodeName === 'A'
            ) {
                const href = event.target.href;

                if (this.loginHandler && (href.includes('&int_src=ref-login') || href.includes('&int_src=ref-signup'))) {
                    event.preventDefault();

                    this.loginHandler(href.includes('&int_src=ref-signup') ? 'register' : 'login').then(
                        (resolve: any) => {
                            console.info(resolve);
                        }
                    ).catch(
                        (err: any) => {
                            console.error(err);
                        }
                    )
                }

                if (this.logoutHandler && href.includes('&int_src=ref-logout')) {
                    event.preventDefault();

                    this.logoutHandler().then(
                        (resolve: any) => {
                            console.info(resolve);
                        }
                    ).catch(
                        (err: any) => {
                            console.error(err);
                        }
                    )
                }
            }
        })
    }

    public registerCustomLoginHandler(handler: Function) {
        this.loginHandler = handler;
        window._FSAccountMenu = (accountMenuData: any) => {
            this.handleAccountData(accountMenuData)
        }
    }

    public checkForLogin(): Promise<void> {
        return new Promise((resolve, reject) => {
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.setAttribute('id', 'xAuth');

            const postMessageHandler = (e: any) => {
                if (this.webAccountsUrl && this.webAccountsUrl.indexOf(e.origin) != -1 && e.data.hasOwnProperty('accountsConfig')) {
                    const accountsConfig = e.data.accountsConfig;

                    // check for slash at the end
                    if (accountsConfig?.domain && accountsConfig.domain.slice(-1) !== '/') accountsConfig.domain += '/';

                    // Map this data.
                    Object.assign(accountsConfig, {
                        avatarUrl: accountsConfig.avatar,
                        waLinks: accountsConfig.links,
                        defaultDomain: accountsConfig.domain
                    })

                    this.handleAccountData(accountsConfig);
                    resolve();

                    window.removeEventListener('message', postMessageHandler);
                    document.body.removeChild(iframe);
                } else {
                    reject();
                }
            }
            // append the listener for accounts messages
            window.addEventListener('message', postMessageHandler);

            // Fetch user cookie if is set on site.
            const csid = this.getUserCookie();
            iframe.src = this.webAccountsUrl + 'ext/get-auth' + (csid ? '?csid=' + csid : '');
            document.body.appendChild(iframe);
        })
    }

    public handleAccountData(accountMenuData: any) {
        if (accountMenuData) {

            // check for slash at the end
            if (accountMenuData.defaultDomain?.slice(-1) !== '/') accountMenuData.defaultDomain += '/';

            const eventData: {
                id: string;
                member: boolean;
                avatar: string;
                userReferralLink: string;
                clientName: string;
                links: any[];
                domain: string;
                gtmUserDetails: any;
                assets?: {
                    styleLink: string
                }
            } = {
                id: accountMenuData.userId,
                member: accountMenuData.member,
                clientName: accountMenuData.clientName,
                userReferralLink: accountMenuData.userReferralLink,
                avatar: accountMenuData.avatarUrl?.indexOf('person@2x.png') !== -1 ? null : accountMenuData.avatarUrl.replace('/64/64', ''),
                links: accountMenuData.waLinks,
                domain: accountMenuData.defaultDomain,
                gtmUserDetails: null,
                assets: accountMenuData.assets
            };

            if (eventData.assets?.styleLink) {
                this.appendIconStyle(eventData.assets.styleLink)
            }

            dispatchCustomEvent('obf-authentication-event', {
                message: accountMenuData,
                time: new Date()
            });

            this.dataLayerEventPusher(eventData.id, eventData.member, eventData.gtmUserDetails);

            this.executeOnAllWAContainers((container, type) => {

                container.innerHTML = '';
                
                if (type === 'all') {
                    this.appendButton(container, type);
                } 
                
                this.appendMenu(container, eventData, type);
            })

        } else {
            this.executeOnAllWAContainers((container, type) => {
                container.innerHTML = '';
                this.appendButton(container, type);
            })

            dispatchCustomEvent('obf-authentication-event', {
                message: null,
                time: new Date()
            });
        }
    }

    private addStyleForLogin() {

        const menuLayoutContainer = document.querySelectorAll('[data-menu-layout]');

        // get the hover color from the first match, if missing - set the same like pirmary
        const menuPrimaryColorAttr = menuLayoutContainer && menuLayoutContainer.length && menuLayoutContainer[0].getAttribute('data-menu-primary-color') ? menuLayoutContainer[0].getAttribute('data-menu-primary-color') : '#e83e8c',
        menuPrimaryColorDarkAttr = menuLayoutContainer && menuLayoutContainer.length && menuLayoutContainer[0].getAttribute('data-menu-primary-color-dark') ? menuLayoutContainer[0].getAttribute('data-menu-primary-color-dark') : menuPrimaryColorAttr;

        const waLoginMenuStyle = '.web-account, .web-account .logged .iconarrow { position: relative; display: inline-block; } .m-web-account a, .web-account a { text-decoration: none; } .web-account .login a { color: #015b98; text-transform: uppercase; display: inline-block; } .web-account .logged { margin-left: 0; } .web-account .logged .user-img { width: 32px; height: 32px; border-radius: 50%; display: inline-block; vertical-align: middle; } .web-account .logged .iconarrow { font-size: 0; width: 2px; height: 10px; margin: 0 -8px 0 18px; vertical-align: middle; -webkit-transition: all 0.2s ease-in-out; -moz-transition: all 0.2s ease-in-out; -o-transition: all 0.2s ease-in-out; transition: all 0.2s ease-in-out; } .web-account .logged .iconarrow:after, .web-account .logged .iconarrow:before { content: ""; position: absolute; right: 10px; top: 50%; -webkit-transform: translateY(-50%); transform: translateY(-50%); width: 2px; height: 7px; background-color: #064e81; -webkit-transition: all 0.2s ease-in-out; -moz-transition: all 0.2s ease-in-out; -o-transition: all 0.2s ease-in-out; transition: all 0.2s ease-in-out; } .web-account .logged .iconarrow:before { -webkit-transform: translate(-3.5px, -50%) rotate(-45deg); transform: translate(-3.5px, -50%) rotate(-45deg); } .web-account .logged:hover .iconarrow:before { -webkit-transform: translate(-3.5px, -50%) rotate(-135deg); transform: translate(-3.5px, -50%) rotate(-135deg); } .web-account .logged:hover .iconarrow:after { -webkit-transform: translate(0, -50%) rotate(135deg); transform: translate(0, -50%) rotate(135deg); } .web-account .logged .iconarrow:after { -webkit-transform: translate(0, -50%) rotate(45deg); transform: translate(0, -50%) rotate(45deg); } .web-account .logged .wa-links { visibility: hidden; opacity: 0; margin: 0; transition: all 0.2s ease-in-out; position: absolute; width: 225px; background: #fff; right: -35px; top: 80%; border: 1px solid #e7e7e7; text-align: left; border-radius: 8px; padding: 0; } .web-account .logged:hover .wa-links { visibility: visible; opacity: 1; top: 90%; } .web-account .logged .wa-links, .web-account .logged .wa-links li a { -webkit-transition: all 0.2s ease-in-out; -moz-transition: all 0.2s ease-in-out; -o-transition: all 0.2s ease-in-out; } .web-account .logged .wa-links li { display: block; } .web-account .logged .wa-links li .menu-item-icon { margin-right: 13px; font-size: 16px; position: relative; top: 2px; display: inline-block; height: 20px; width: 20px; } .web-account .logged .wa-links li a { line-height: 120%; text-transform: none; display: block; color: #0c5d96; font-size: 15px; padding: 10px 10px 10px 13px; border-bottom: 1px solid #efefef; transition: all 0.2s ease-in-out; } .web-account .logged .wa-links li a:hover { color: #00a8e3; } .web-account .logged .wa-links li a:before { vertical-align: middle; margin-right: 20px; } .web-account .logged .wa-links:after, .web-account .logged .wa-links:before { left: 81%; bottom: 100%; border: solid transparent; content: ""; height: 0; width: 0; position: absolute; pointer-events: none; } .web-account .logged .wa-links:before { border-bottom-color: #e7e7e7; border-width: 11px; margin: 0 0 0 -11px; } .web-account .logged .wa-links:after { border-bottom-color: #fff; border-width: 10px; margin: 0 0 0 -10px; } .m-web-account { height: 170px; background: #0c5d96; background-size: cover; text-align: center; position: relative; } .m-web-account .profile { position: absolute; width: 100%; top: 50%; -webkit-transform: translateY(-50%); transform: translateY(-50%); } .m-web-account .profile a.photo-wrap { display: block; float: none; width: 73px; height: 73px; border-radius: 50%; padding: 3px; border: 1px solid rgba(255, 255, 255, 0.08); margin: 0 auto 25px; } .m-web-account .profile a { color: #fff; width: 50%; float: left; text-transform: uppercase; font-size: 15px; position: relative; } .m-web-account .profile a.photo-wrap .circle { display: inline-block; border-radius: 50%; border: 1px solid rgba(255, 255, 255, 0.15); padding: 3px; width: 65px; height: 65px; } .m-web-account .profile a.photo-wrap .user-img { width: 57px; height: 57px; border: 1px solid rgba(255, 255, 255, 0.15); border-radius: 50%; display: block; margin: 0 auto; } .m-web-account a { display: inline-block; } .m-web-account .profile:before { content: ""; display: block; height: 40px; width: 1px; opacity: 0.7; position: absolute; left: 50%; bottom: -10px; background: -moz-linear-gradient( top, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.8) 25%, rgba(255, 255, 255, 0.81) 26%, #fff 42%, #fff 55%, rgba(255, 255, 255, 0.81) 74%, rgba(255, 255, 255, 0.8) 75%, rgba(255, 255, 255, 0) 100% ); background: -webkit-linear-gradient( top, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.8) 25%, rgba(255, 255, 255, 0.81) 26%, #fff 42%, #fff 55%, rgba(255, 255, 255, 0.81) 74%, rgba(255, 255, 255, 0.8) 75%, rgba(255, 255, 255, 0) 100% ); background: linear-gradient( to bottom, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.8) 25%, rgba(255, 255, 255, 0.81) 26%, #fff 42%, #fff 55%, rgba(255, 255, 255, 0.81) 74%, rgba(255, 255, 255, 0.8) 75%, rgba(255, 255, 255, 0) 100% ); filter: progid: DXImageTransform.Microsoft.gradient(startColorstr="#00ffffff", endColorstr="#00ffffff", GradientType=0); } .wa-links .menu-item a span.icon-notification-counter.visible { opacity: 1; } .wa-links .menu-item a span.icon-notification-counter { background-color: #63788F; color: #fff; position: absolute; opacity: 1; font-size: 14px; font-family: ralewaybold, Arial, Helvetica, sans-serif; font-weight: 400; line-height: 26px; width: 26px; height: 26px; right: 18px; border-radius: 50%; margin-top: 0; text-align: center; transition: all 0.2s ease-in-out;}';

        const layoutMenuStyle =
            '.accounts-menu-holder { position: relative } .accounts-menu-holder .helper-anchor-element { display: none; position: absolute; width: 100%; height: 100%; top: 0; left: 0; } .accounts-menu-holder .acc-avatar {pointer-events:none; display: flex; font-family: Lato, "Lucida Grande", Tahoma, Sans-Serif; overflow: hidden; width: 24px; height: 24px; border-radius: 50%; margin-right: 5px; vertical-align: middle;} .accounts-menu-holder .menu-arrow {font-size: 0;  width: 0; height: 10px; margin: 0 -8px 0 18px; position: relative; display: inline-block; vertical-align: middle;  -webkit-transition: all .2s ease-in-out; -moz-transition: all .2s ease-in-out; -o-transition: all .2s ease-in-out; transition: all .2s ease-in-out;} .accounts-menu-holder .menu-arrow:before, .accounts-menu-holder .menu-arrow:after { content: ""; position: absolute;  right: 10px; top: 50%; -webkit-transform: translateY(-50%); transform: translateY(-50%);  width: 2px; height: 7px; background: inherit;  -webkit-transition: all 0.2s ease-in-out; -moz-transition: all 0.2s ease-in-out; -o-transition: all 0.2s ease-in-out; transition: all 0.2s ease-in-out;} .accounts-menu-holder .menu-arrow:before {-webkit-transform: translate(-3.5px, -50%) rotate( -45deg ); transform: translate(-3.5px, -50%) rotate( -45deg );}.accounts-menu-holder .menu-arrow:after {-webkit-transform: translate(0, -50%) rotate( 45deg );  transform: translate(0, -50%) rotate( 45deg );} .accounts-menu-holder .accounts-menu-list {border-bottom-right-radius: 5px; border-bottom-left-radius: 5px; background: #fff; box-shadow: 0 4px 10px #e8eaec; } .accounts-menu-list ul { margin: 0; overflow: hidden; padding: 0; text-align: left; background-color: #fff; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; border: 1px solid #efefef; } .accounts-menu-list:before, .accounts-menu-list:after { right: 15px; top: -9px; border: solid transparent; content: ""; height: 0; width: 0; position: absolute; pointer-events: none; } .accounts-menu-list:before { border-width: 10px; margin: 0 0 0 -11px; border-bottom-color: #8b8b8b;} .accounts-menu-list:after { border-bottom-color: #ffffff; border-width: 10px; margin: 0 0 0 -10px; } .accounts-menu-list ul li:last-child { border: none; border-bottom-right-radius: 5px; border-bottom-left-radius: 5px; } .accounts-menu-list ul li { border-bottom: 1px solid #efefef; display: block; } .accounts-menu-list ul li a { display: block; background-color: #fff; color: #394e66; padding: 12px 22px; }  .accounts-menu-list ul li a span {display: inline-block; vertical-align: middle; line-height: 1em;} .accounts-menu-list ul li a span.menu-item-icon {color: #63788f; position: relative; font-size: 20px; display: inline-block; height: 20px; width: 20px; } .accounts-menu-list ul li a span.menu-item-title { margin-left: 20px;} .accounts-menu-holder.logged-template .accounts-menu-list-wrapper { display: none; } .accounts-menu-holder .logged, .accounts-menu-holder .accounts-menu-list-wrapper {     -webkit-transition: all .2s ease-in-out;-moz-transition: all .2s ease-in-out;-o-transition: all .2s ease-in-out; transition: all .2s ease-in-out; padding-top: 10px; z-index: 999; visibility: hidden; opacity: 0; position: absolute; top: 80%; right: -20px; width: 265px;}  .not-logged-content { text-align: center; border-bottom-right-radius: 5px; border-bottom-left-radius: 5px; overflow: hidden; } .not-logged-content .has-account-section { border: 1px solid #e8eaec; border-bottom: none; background: #fff; padding: 18px 20px 13px 20px } .not-logged-content .has-account-section .click-to-login { font-weight: bold; font-size: 16px; border-radius: 6px; display: inline-block; padding: 10px 22px; text-align: center; min-width: 200px; } .not-logged-content .has-account-section .click-to-login:hover { background: '+ menuPrimaryColorDarkAttr +' !important; } .not-logged-content .has-account-section .title { display: block; font-size: 16px; margin-bottom: 10px; } .not-logged-content .no-account-section { background: grey; text-align: center; padding: 15px; } .not-logged-content .no-account-section .click-to-register { display: inline-block; font-size: 14px } .not-logged-content .no-account-section .click-to-register span { font-weight: bold; } .accounts-menu-list ul li a span.icon-notification-counter.visible { opacity: 1; } .accounts-menu-list ul li a span.icon-notification-counter { background-color: #bebebe; color: #fff; position: absolute; opacity: 1; font-size: 14px; font-weight: bold; font-weight: 400; line-height: 26px; width: 26px; height: 26px; right: 18px; border-radius: 50%; margin-top: 0; text-align: center; transition: all 0.2s ease-in-out;} @media (hover: hover) {.accounts-menu-list ul li a:hover { color: #394e66; background-color: #f0f3f7; } .accounts-menu-holder:hover a { text-decoration: none; } .accounts-menu-holder:hover .logged, .accounts-menu-holder:hover .accounts-menu-list-wrapper { visibility: visible; opacity: 1; top: 100%; }.accounts-menu-holder:hover .menu-arrow:before { -webkit-transform: translate(-3.5px, -50%) rotate(-135deg);transform: translate(-3.5px, -50%) rotate(-135deg)} .accounts-menu-holder:hover .menu-arrow:after {-webkit-transform: translate(0, -50%) rotate( 135deg ); transform: translate(0, -50%) rotate( 135deg );}} @media only screen and (max-width: 1199px) { .accounts-menu-holder:not(.logged-template) .helper-anchor-element { display: block; } .accounts-menu-holder.show-logged-menu .logged { visibility: visible; opacity: 1; top: 100%; display: block !important; } .accounts-menu-list-wrapper {display: none !important} .accounts-menu-holder div.logged {display:none !important} .accounts-menu-holder .menu-arrow {display:none !important} } @media only screen and (max-width: 768px) {   }';


        // this.avatarUrlMobile = '';
        // this.avatarUrlDesktop = '';

        if (this.webAccountsUrl && this.webAccountsUrl.indexOf('fantatsticservices') != -1) {
            // Brand default profile images
            this.avatarUrlMobile = this.appUrl + 'basic-profile.svg';
            this.avatarUrlDesktop = this.appUrl + 'basic-profile.svg';
        } else {
            // Other/Nonbrand/Clients default profile images
            this.avatarUrlMobile = this.appUrl + 'basic-profile.svg';
            this.avatarUrlDesktop = this.appUrl + 'basic-profile.svg';
        }


        const loginStyle = document.createElement('style');

        let menuStyle = '';

        // WA Login Menu Style
        if (this.loginSettings?.waLoginContainerDesktop.length || this.loginSettings?.waLoginContainerMobile.length) {
            menuStyle += waLoginMenuStyle;
        }

        // Layout Menu Style
        if (this.loginSettings?.waMenuContainer.length) {
            menuStyle += layoutMenuStyle;
        }

        // Append Menu style in <head></head>
        if (menuStyle) {
            loginStyle.innerHTML = menuStyle;
            document.head.appendChild(loginStyle);
        }

        return loginStyle;
    }

    private appendIconStyle(iconHref: string) {
        if (!document.querySelector(`link[href="${iconHref}"]`)) {
            const iconStyle = document.createElement('link');
            iconStyle.rel = 'stylesheet';
            iconStyle.href = iconHref;
            document.head.appendChild(iconStyle)
        }
    }

    private dataLayerEventPusher(userId: string, member: boolean, gtmUserDetails: string) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'eventName': 'userLoginData',
            'userID': userId,
            'member': member
        });

        if (gtmUserDetails != null) {
            window.dataLayer.push(gtmUserDetails);
        }
    }

    private appendButton(menuContainer: HTMLElement, type: 'desktop' | 'mobile' | 'all') {
        // Inject Login Button html
        let button;

        if (type === 'mobile') {
            button = this.createLoginButtonForMobile();
        } else if (type === 'desktop') {
            button = this.createLoginButtonForDesktop();
        } else if (type === 'all') {
            button = this.createMenuLayout(menuContainer);
        }

        menuContainer.appendChild(button);
    }

    private getNameInitials(name) {

        if (!name) return '';

        const fullName = name.split(' ');
        const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);

        return initials.toUpperCase();
    }

    private hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    private createMenuLayout(menuContainer): HTMLElement {

        let parentCookies = getParentCookies();
        let gclid, gclid_query = ''; 

        // Set gclid if exist in parent cookies
        if (parentCookies?.hasOwnProperty('_gcl_aw')) {
            gclid = getGoogleCookieId(parentCookies['_gcl_aw']);
            gclid_query = "&gclid=" + gclid;
        }

        const layoutElement = document.createElement('div'),
            wrapElement = document.createElement('div'),
            helperAnchorElement = document.createElement('a'),
            menuElement = document.createElement('div'),
            menuTitleAttr = menuContainer.getAttribute('data-menu-title-text') ? menuContainer.getAttribute('data-menu-title-text') : 'MY ACCOUNT',
            menuHeadingText = menuContainer.getAttribute('data-menu-heading-text') ? menuContainer.getAttribute('data-menu-heading-text') : 'Already have an account?',
            menuFooterTextPart1 = menuContainer.getAttribute('data-menu-footer-text-part1') ? menuContainer.getAttribute('data-menu-footer-text-part1') : 'No Account?',
            menuFooterTextPart2 = menuContainer.getAttribute('data-menu-footer-text-part2') ? menuContainer.getAttribute('data-menu-footer-text-part2') : 'Start here',
            menuCTAText = menuContainer.getAttribute('data-menu-cta-text') ? menuContainer.getAttribute('data-menu-cta-text') : 'Log in',
            menuLayoutAttr = menuContainer.getAttribute('data-menu-layout') ? menuContainer.getAttribute('data-menu-layout') : 'default',
            
            menuPrimaryColorAttr = menuContainer.getAttribute('data-menu-primary-color') ? menuContainer.getAttribute('data-menu-primary-color') : '#e83e8c',
            menuSecondaryColorAttr = menuContainer.getAttribute('data-menu-secondary-color') ? menuContainer.getAttribute('data-menu-secondary-color') : '#005a96',
            menuTitleColorAttr = menuContainer.getAttribute('data-menu-title-color') ? menuContainer.getAttribute('data-menu-title-color') : '#000000',
            menuTextColorAttr = menuContainer.getAttribute('data-menu-text-color') ? menuContainer.getAttribute('data-menu-text-color') : '#000000',
            menuButtonTextColorAttr = menuContainer.getAttribute('data-menu-button-text-color') ? menuContainer.getAttribute('data-menu-button-text-color') : '#ffffff',
            menuBackgroundColorAttr = menuContainer.getAttribute('data-menu-background-color') ? menuContainer.getAttribute('data-menu-background-color') : '#eff1fe',
            menuIntegratedPagesAttr = menuContainer.getAttribute('data-menu-integrated-pages') && menuContainer.getAttribute('data-menu-integrated-pages') == 'true' ? true : false;

        this.logoutText = menuContainer.getAttribute('data-menu-logout-text') ? menuContainer.getAttribute('data-menu-logout-text') : 'Log Out';

        const clientFullNameInitials = this.getNameInitials(this.clientFullName);

        let menuAvatarHTML = '<span class="acc-avatar" ><svg style="pointer-events:none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path style="fill:' + menuTitleColorAttr + '; id="Profile" d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,23.108A11.053,11.053,0,0,1,5.139,20.73a4.378,4.378,0,0,1,4.363-4.1H14.5a4.378,4.378,0,0,1,4.363,4.1A11.053,11.053,0,0,1,12,23.108Zm7.67-3.08A5.273,5.273,0,0,0,14.5,15.739H9.5A5.273,5.273,0,0,0,4.33,20.027a11.108,11.108,0,1,1,15.34,0ZM12,4.8a4.97,4.97,0,1,0,4.97,4.97A4.976,4.976,0,0,0,12,4.8Zm0,9.048a4.078,4.078,0,1,1,4.078-4.078A4.083,4.083,0,0,1,12,13.847Z"/></svg></span>';

        if (clientFullNameInitials && (this.avatarUrlDesktop && this.avatarUrlDesktop.indexOf('basic-profile') > -1 || !this.avatarUrlDesktop)) {
            // logged and missing avatar img
            menuAvatarHTML = menuLayoutAttr === 'default' || menuLayoutAttr === 'avatar' ? '<span class="acc-avatar" style="display: block; font-size: 12px; text-align: center; line-height: 24px; background:' + menuBackgroundColorAttr + '; color:' + menuSecondaryColorAttr + '; ">' + clientFullNameInitials + '</span>' : '';
        } else if (clientFullNameInitials && this.avatarUrlDesktop && this.avatarUrlDesktop.indexOf('basic-profile') === -1) {
            // logged with present image url from accounts
            menuAvatarHTML = menuLayoutAttr === 'default' || menuLayoutAttr === 'avatar' ? '<span class="acc-avatar" style="font-size: 12px; text-align: center; line-height: 24px; "><img style="pointer-events:none; width: 100%; vertical-align: top;" src=' + this.avatarUrlDesktop + '></span>' : '';
        } else {
            // use default svg avatar for not logged users
            if (menuLayoutAttr === 'text') {
                menuAvatarHTML = '';
            }
        }

        const loginHref = menuIntegratedPagesAttr ? 'javascript:void(0)' : this.webAccountsUrl + 'ext/auth?wa_sr=0&redirect_uri=' + window.location.href + '&int_src=ref-login' + gclid_query;
        const registerHref = menuIntegratedPagesAttr ? 'javascript:void(0)' : this.webAccountsUrl + 'create-account?callback=' + window.location.href + '&int_src=ref-signup' + gclid_query;
        const bookAttr = menuIntegratedPagesAttr ? 'data-book-btn="true"' : '';
        const loginScreenAttr = menuIntegratedPagesAttr ? 'data-screen="login"' : '';
        const registerScreenAttr = menuIntegratedPagesAttr ? 'data-screen="register"' : '';

        const menuTextHTML = menuLayoutAttr === 'default' || menuLayoutAttr === 'text' ? '<span class="acc-link" style="display: inline-block; line-height: 14px; margin-right:5px; font-size: 14px; color: ' + menuTitleColorAttr + '; vertical-align: middle;"> ' + menuTitleAttr + ' </span>' : '';

        helperAnchorElement.classList.add('helper-anchor-element');

        // the menu on mobile when not logged is just a link - on integrated pages the link should open obf with login modal
        if (menuIntegratedPagesAttr) {
            helperAnchorElement.setAttribute('data-book-btn', 'true'); 
            helperAnchorElement.setAttribute('data-screen', 'login'); 
        }

        helperAnchorElement.href = menuIntegratedPagesAttr ? 'javascript:void(0)' : this.webAccountsUrl + 'ext/auth?wa_sr=0&redirect_uri=' + window.location.href + '&int_src=ref-login'+ gclid_query;
        wrapElement.classList.add('wrap-element');
        wrapElement.innerHTML = '<span style="pointer-events:none; padding-right: 0; min-height: 24px; position: relative; display: flex; align-items: center; justify-content: center;"> ' + menuAvatarHTML + ' ' + menuTextHTML + ' <i class="menu-arrow" style="background: ' + menuPrimaryColorAttr + ';"></i> </span>';

        menuElement.classList.add('accounts-menu-list-wrapper');
        menuElement.innerHTML = '<div class="accounts-menu-list not-logged-content"><div class="has-account-section"><span class="title">'+menuHeadingText+'</span><a '+bookAttr + loginScreenAttr +' style="background:' + menuPrimaryColorAttr + '; color:' + menuButtonTextColorAttr + '" href="' + loginHref + '" class="click-to-login bold">'+menuCTAText+'</a></div><a '+bookAttr + registerScreenAttr+' href="' + registerHref + '" style="display: block; background: ' + menuBackgroundColorAttr +'" class="no-account-section"><span style="color:' + menuTextColorAttr + '"  class="click-to-register">'+menuFooterTextPart1+' <span style="color:' + menuSecondaryColorAttr + '">'+menuFooterTextPart2+'</span></span></a></div>';

        layoutElement.style.position = "relative";
        layoutElement.appendChild(wrapElement); 
        layoutElement.appendChild(helperAnchorElement); 
        layoutElement.appendChild(menuElement);

        return layoutElement;
    }

    private createLoginButtonForDesktop(): HTMLElement {
        const loginButtonDesktop = document.createElement('div');
        let parentCookies = getParentCookies();
        let gclid, gclid_query = ''; 

        // Set gclid if exist in parent cookies
        if (parentCookies?.hasOwnProperty('_gcl_aw')) {
            gclid = getGoogleCookieId(parentCookies['_gcl_aw']);
            gclid_query = "&gclid=" + gclid;
        }
        loginButtonDesktop.style.display = 'block';
        loginButtonDesktop.setAttribute('class', 'login');

        const loginHTMLDesktop = document.createElement('a');
        loginHTMLDesktop.href = this.webAccountsUrl + 'ext/auth?wa_sr=0&redirect_uri=' + window.location.href + '&int_src=ref-login' + gclid_query;
        loginHTMLDesktop.rel = 'nofollow';
        loginHTMLDesktop.id = 'desktop-menu';
        loginHTMLDesktop.text = 'Log In';

        loginButtonDesktop.appendChild(loginHTMLDesktop);

        return loginButtonDesktop;
    }

    private createLoginButtonForMobile(): HTMLElement {
        const loginButtonMobile = document.createElement('div');
        let parentCookies = getParentCookies();
        let gclid, gclid_query = ''; 

        // Set gclid if exist in parent cookies
        if (parentCookies?.hasOwnProperty('_gcl_aw')) {
            gclid = getGoogleCookieId(parentCookies['_gcl_aw']);
            gclid_query = "&gclid=" + gclid;
        }

        loginButtonMobile.style.display = 'block';
        loginButtonMobile.setAttribute('class', 'login');

        const loginHTMLMobile =
            '<div id="mobile-menu" class="profile login" style="display: block;">\
                                                    <div class="photo-wrap">\
                                                        <a style="font-size:0px" href="javascript:void(0)" class="photo-wrap">\
                                                            photo<div class="circle">\
                                                                <div class="user-img" style="background-image: url(' +
            this.avatarUrlMobile +
            '); background-repeat: no-repeat; background-position: center center; background-size: cover;background-color: #e9ecef;"></div>\
                                                            </div>\
                                                        </a>\
                                                    </div>\
                                                    <a href="' +
            this.webAccountsUrl +
            'ext/auth?wa_sr=0&redirect_uri=' +
            window.location.href +
            '&int_src=ref-login' + gclid_query + '" rel="nofollow">Log In</a>\
                                                    <a href="' +
            this.webAccountsUrl +
            'create-account?wa_sr=0&callback=' +
            window.location.origin +
            '&int_src=ref-signup' + gclid_query + '" rel="nofollow">Sign Up</a>\
                                                </div>';

        loginButtonMobile.innerHTML = loginHTMLMobile;

        return loginButtonMobile;
    }

    private appendMenu(menuContainer: HTMLElement, eventData: any, type: 'desktop' | 'mobile' | 'all') {

        let integratedPagesEnabled = false;

        let parentCookies = getParentCookies();
        let gclid, gclid_query = ''; 

        // Set gclid if exist in parent cookies
        if (parentCookies?.hasOwnProperty('_gcl_aw')) {
            gclid = getGoogleCookieId(parentCookies['_gcl_aw']);
            gclid_query = "&gclid=" + gclid;
        }

        const integratedPageslinks = [
            {
                iconClass: "wa-icon-calendar",
                pageName: "Bookings",
                pageUrl: "bookings",
                showOnExternal: true
            },
            {
                iconClass: "wa-icon-settings",
                pageName: "Account Settings",
                pageUrl: "accounts_settings",
                showOnExternal: true
            },
            {
                iconClass: "wa-icon-notifications",
                pageName: "Notifications",
                pageUrl: "notifications",
                showOnExternal: true
            }
        ]

        if (menuContainer && menuContainer.getAttribute('data-menu-integrated-pages') == 'true') {
            integratedPagesEnabled = true
        }

        this.clientFullName = eventData.clientName;

        let userId = eventData.id,
            clientName = eventData.clientName,
            member = eventData.member,
            avatarUrl = eventData.avatar,
            referralLink = eventData.userReferralLink,
            waLinks = integratedPagesEnabled ? integratedPageslinks : eventData.links,
            defaultDomain = eventData.domain,
            gtmUserDetails = eventData.gtmUserDetails,
            menuLinks = '';

        // check for slash at the end
        if (defaultDomain.slice(-1) !== '/') defaultDomain += '/';

        if (avatarUrl) {
            avatarUrl += '/64/64';
            (this.avatarUrlDesktop = avatarUrl), (this.avatarUrlMobile = avatarUrl);
        }

        // rerender menu layout with new avatar img
        if (type === 'all') {
            menuContainer.innerHTML = '';
            this.appendButton(menuContainer, type);
        }

        if (waLinks != null) {
            menuLinks = this.menuLinksBuilder(waLinks, defaultDomain, integratedPagesEnabled);
        }
        const loginMenu = document.createElement('div');

        loginMenu.style.display = 'block';
        loginMenu.setAttribute('class', 'logged');

        if (type === 'mobile') {
            // Inject Logged Menu Mobile
            const loggedHTMLMobile =
                '<div id="mobile-menu" data-wa-client-name="' + clientName + '" data-wa-user-id="' +
                userId +
                '" data-wa-user-member="' +
                member +
                '" class="profile logged" style="display:block;">\
                                                        <a style="font-size:0px" href="' +
                defaultDomain +
                '" class="photo-wrap">\
                                                            photo<div class="circle">\
                                                                <div class="user-img" style="background-image: url(' +
                this.avatarUrlMobile +
                '); background-repeat: no-repeat; background-position: center center; background-size: cover;background-color: #e9ecef;"></div>\
                                                            </div>\
                                                        </a>\
                                                        <a href="' +
                defaultDomain +
                'dashboard/?redirect_uri=' +
                window.location.href +
                '&int_src=ref-login' + gclid_query + '"  >My Account</a>\
                                                        <a href="' +
                defaultDomain +
                'ext/logout?redirect_uri=' +
                window.location.href +
                '&int_src=ref-logout" class="logout" >Log Out</a>\
                                                    </div>';

            loginMenu.innerHTML = loggedHTMLMobile;

        } else if (type === 'desktop') {
            // Inject Logged Menu Desktop
            const loggedHTMLDesktop =
                '<div id="desktop-menu" data-wa-client-name="' + clientName + '" data-wa-user-id="' +
                userId + '" data-wa-referral-link="' +
                referralLink +
                '" data-wa-user-member="' +
                member +
                '"></div>\
                                <div class="user-img" style="background-image: url(' +
                this.avatarUrlDesktop +
                '); background-repeat: no-repeat; background-position: center center; background-size: cover;background-color: #e9ecef;"></div>\
                                <span class="iconarrow"></span>\
                                <ul class="wa-links">\
                                ' +
                menuLinks +
                '\
                            </ul>';

            loginMenu.innerHTML = loggedHTMLDesktop;
        } else if (type === 'all') {
            menuContainer.classList.add('logged-template');
            loginMenu.innerHTML = '<div class="accounts-menu-list"><ul>' + menuLinks + '</ul></div>';
        }
        // clear menu container from inside elements.
        menuContainer.appendChild(loginMenu);
    }

    private menuLinksBuilder(waLinks: any, defaultDomain: string, integratedPagesEnabled: boolean = false) {
        let menuLinks = '';
        let logoutText = this.logoutText;
        let parentCookies = getParentCookies();
        let gclid = ''; 

        // check for slash at the end
        if (defaultDomain.slice(-1) !== '/') defaultDomain += '/';

        // Set gclid if exist in parent cookies
        if (parentCookies?.hasOwnProperty('_gcl_aw')) {
            gclid = getGoogleCookieId(parentCookies['_gcl_aw']);
        }

        waLinks.map((links: any) => {
            if (links.showOnExternal) {
                // For Dollars we are using other fonts
                let href = integratedPagesEnabled ? 'javascript:void(0)' : links.pageUrl +
                    '?redirect_uri=' +
                    window.location.href +
                    '&int_src=' +
                    links.pageName;
                
                // Add gclid to menu items href
                if (gclid && !integratedPagesEnabled) href += '&gclid=' + gclid;

                const iconUrl = links?.iconUrl ? "background: url('" + links.iconUrl + "') 0 50% no-repeat" : "";
                const bookAttr = integratedPagesEnabled ? 'data-book-btn="true"' : '';
                const screenAttr = integratedPagesEnabled ? 'data-screen="' + links.pageUrl + '"' : '';
                let iconClass = '';

                if (!links?.iconUrl) {
                    switch (links.iconClass) {
                        case 'page_icon_dashboard':
                            iconClass = 'wa-icon-home';
                            break;
                        case 'page_icon_bookings':
                            iconClass = 'wa-icon-calendar';
                            break;
                        case 'page_icon_credits':
                            iconClass = 'wa-icon-wallet';
                            break;
                        case 'page_icon_invite_and_earn':
                            iconClass = 'wa-icon-referral';
                            break;
                        case 'page_icon_settings':
                            iconClass = 'wa-icon-settings';
                            break;
                        case 'page_icon_treats':
                            iconClass = 'wa-icon-treats';
                            break;
                        case 'page_icon_notifications':
                            iconClass = 'wa-icon-notifications';
                            break;
                        case 'page_icon_club':
                            iconClass = 'wa-icon-diamond';
                            break;
                        case 'logout':
                            iconClass = 'wa-icon-exit';
                            break;
                        default:
                            iconClass = links.iconClass;
                    }
                }

                if (!links.menuName || links.menuName !== 'logout') {
                    const itemCount =
                        typeof links.itemCount != 'undefined' && links.itemCount != 0
                            ? '<span class="icon-notification-counter notifications-counter visible">' + links.itemCount + '</span>'
                            : '';

                    menuLinks +=
                    '<li class="menu-item" '+ bookAttr + screenAttr +'>\
                    <a href="' + href +'">\
                                    <span class="menu-item-icon ' +
                    iconClass +
                    '" style="' + iconUrl + '"></span>\
                                    <span class="menu-item-title">' +
                    links.pageName +
                    '</span>\
                                    ' +
                    itemCount +
                    '</a>\
                                </li>';
                } else if (links.menuName === 'logout') {
                    menuLinks +=
                    '<li class="menu-item">\
                                            <a href="' +
                    defaultDomain +
                    'ext/logout?redirect_uri=' +
                    window.location.href +
                    '&int_src=ref-logout">\
                                            <span class="menu-item-icon '+ iconClass +'" style="' + iconUrl + '"></span>\
                                            <span class="menu-item-title">'+ links.pageName +'</span>\
                                            </a>\
                                        </li>';
                }
            }
        });

        if (!waLinks.some( e => e.menuName === 'logout')) {
            menuLinks +=
            '<li class="menu-item">\
                                    <a href="' +
            defaultDomain +
            '/ext/logout?redirect_uri=' +
            window.location.href +
            '&int_src=ref-logout">\
                                    <span class="menu-item-icon wa-icon-exit"></span>\
                                    <span class="menu-item-title">'+ logoutText +'</span>\
                                    </a>\
                                </li>';
        }

        return menuLinks;
    }
}
